// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const RefundRequestStatus = {
  Pending: {
    Name: 'Pending',
    Value: 'refund_pending',
  },
  Authorized: {
    Name: 'Authorized',
    Value: 'refund_authorized',
  },
  Processed: {
    Name: 'Processed',
    Value: 'refund_processed',
  },
  Rejected: {
    Name: 'Rejected',
    Value: 'refund_rejected',
  },
} as const

export type RefundRequestStatusValue =
  (typeof RefundRequestStatus)[keyof typeof RefundRequestStatus]['Value']
